import { getWorkDetail, getReplenishWorksType, getAdDetail } from "@/server/interfaces"
import router from "../../router"

export default {
  namespaced: true,
  state: {
    worksDetail: {
      id: "",
      userId: "",
      like: false,
      activityName: "",
      singleShareDesc: "",
      likeNum: 0,
      activityId: "",
      activityCategory: {},
      title: "",
      detail: "",
      recommend: "",
      mediaFiles: [],
      videos: [],
      defaultOptions: [],
      typeId: "",
      worksType: {},
      worksDefaultPic: "",
      reviewStatus: ""
    },
    firstDetail: "",
    submitSuccess: false,
    adDetail: {},
    workDetailIndex: ""
  },
  getters: {
    worksDetail: state => state.worksDetail,
    firstDetail: state => state.firstDetail,
    submitSuccess: state => state.submitSuccess,
    adDetail: state => state.adDetail,
    workDetailIndex: state => state.workDetailIndex
  },
  mutations: {
    setworkDetail(state, workDetail) {
      if (!workDetail || !workDetail.id) {
        router.replace({ path: "/nothingnessWork" })
        return
      }
      workDetail.defaultOptions.forEach(item => {
        const key = item.option
        const value = item.value
        workDetail[key] = value
      })
      switch (workDetail.reviewStatus) {
        case "WAIT":
          workDetail.reviewStatusTxt = "待审核"
          break
        case "PASS":
          workDetail.reviewStatusTxt = "审核通过"
          break
        case "REJECT":
          workDetail.reviewStatusTxt = "审核未通过"
          break
        case "REVOKE":
          workDetail.statusTxt = "已撤回"
          break
      }
      state.firstDetail = workDetail.detail
      workDetail.mediaFiles = workDetail.mediaFiles || []
      workDetail.detail = workDetail.detail.replace(/\n/g, "<p style='margin-bottom: 0.46rem;'></p>")
      workDetail.mediaFiles = workDetail.mediaFiles || []
      if (workDetail.videos) {
        workDetail.videos.reverse().forEach(item => {
          const videoInfo = {
            ...item,
            fileType: "video",
            url: item.videoUrl,
            cover: item.coverImgUrl
          }
          workDetail.mediaFiles.unshift(videoInfo)
        })
      }
      // 测试代码
      // workDetail.mediaFiles.push({
      //   fileType: "video",
      //   url: "https://test-media-external.oss-cn-shenzhen.aliyuncs.com/Act-ss-mp4-hd/8fcf36cc3a58471a88457f0c086db80c.mp4",
      //   transformType: 1,
      //   cover: "https://testpic.nfapp.southcn.com/reveal/image/201907/24/d8cc36d36a85485998a1c8ffa3a8444d.jpg"
      // })
      // 测试代码
      // window.console.log(workDetail)
      state.worksDetail = workDetail
    },
    reviseWorkItem(state, { like = true, likeNum }) {
      state.worksDetail.like = like
      state.worksDetail.likeNum = likeNum
    },
    updataSubmitType(state, status) {
      state.submitSuccess = status
    },
    setAdDetail(state, data) {
      state.adDetail = data
    },
    setWorkDetailIndex(state, index) {
      state.workDetailIndex = index
    }
  },
  actions: {
    async getWorksDetail({ commit }, params) {
      const workDetail = await getWorkDetail(params)
      commit("setworkDetail", workDetail)
    },
    async getWorksType({ commit }, params) {
      const submitTypes = await getReplenishWorksType(params)
      commit("updataSubmitType", submitTypes)
    },
    async getAdDetailInfo({ commit, rootState }, option) {
      const activityId = rootState.activityInfo.activityId
      option.params.activityId = activityId
      const res = await getAdDetail(option)
      commit("setAdDetail", res)
    }
  }
}
